import { vservice } from '@niknevis/vue-modules'
import { PaymentLinkRequest } from '@/modules/transaction/models/payment.model'

@vservice()
export class BasePaymentlinkUseCase {

  isLoading = false
  isSuccess = false

  requestData(data): PaymentLinkRequest {
    if (data.attachment) {
      const formData = new FormData()
      Object.keys(data).forEach(key => {
        formData.set(key, data[key])
      })
      data = formData as any
    }
    return data
  }
}
